import { Reducer } from 'redux'
import { DetailPageActions, DetailPageActionTypes } from '../actions'
import { DeviceEntry } from '@utils'

export type DeviceEntries = DeviceEntry[] | undefined
export const emptyDeviceEntries:DeviceEntries = undefined

export type Devices = {
  deviceEntries: DeviceEntries
}

const initialState : Devices = {
  deviceEntries: emptyDeviceEntries
}

export const reducer: Reducer<Devices, DetailPageActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.GetDevices:
      return action.output

    default:
      return state
  }
}